export const initialState = {
  organization: {},
  loading: false
};
